export default __webpack_public_path__ + "locales/bg/Common.json?hash=554eff3f6af376644e002729afb6fea1";